// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VeeValidate from 'vee-validate'
import Vuelidate from 'vuelidate'
import VueAlertify from "vue-alertify"
import VCalendar from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import './fonts/HELR65W.woff'
import './fonts/Roboto-Regular.woff'
import keycloak from './Keycloak'; // Import the keycloak instance

window.$ = require('jquery')
window.JQuery = require('jquery')


Vue.use(VueAlertify)
Vue.use(VeeValidate)
Vue.use(Vuelidate)

Vue.use(BootstrapVue)
Vue.use(VCalendar)
Vue.use(keycloak)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js